import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, DatePicker, Drawer, Form, Input, Select } from 'antd';
import { useEffect, useState } from "react";
// import FormService from '../../redux/services/forms';
// import { FILTERS_APPLIED } from '../../redux/types';
import dayjs from 'dayjs';
import { useParams } from "react-router-dom";
import FormService from '../../../redux/services/forms';


const { Option } = Select;
const { RangePicker } = DatePicker;


const RecordsFilter = (props) => {
    const { formId } = useParams();
    const [flags, setFlags] = useState([]);
    const [visible, setVisible] = useState(false);
    const [hasFilter, setHasFilter] = useState(false);
    const [form] = Form.useForm();

    const showDrawer = () => {
        setVisible(!visible);
    };

    useEffect(() => {
        if (props?.default_filter?.selectedFormId != formId) {
            return;
        }

        if (props?.default_filter?.created_at__gte && props?.default_filter?.created_at__lte) {
            let _dates = [dayjs(props?.default_filter.created_at__gte), dayjs(props?.default_filter.created_at__lte)]
            form.setFieldsValue({ dates: _dates });
            setHasFilter(true);
        }
        if (props?.default_filter?.name) {
            form.setFieldsValue({ name: props?.default_filter.name });
            setHasFilter(true);
        }
        if (props?.default_filter?.flag) {
            form.setFieldsValue({ flag: props?.default_filter.flag });
            setHasFilter(true);
        }
        if (props?.default_filter?.created_by__username__icontains) {
            form.setFieldsValue({ user_name: props?.default_filter.created_by__username__icontains });
            setHasFilter(true);
        }
        if (props?.default_filter?.updated_by__username__icontains) {
            form.setFieldsValue({ user_name2: props?.default_filter.updated_by__username__icontains });
            setHasFilter(true);
        }
        if (props?.default_filter?.record_id__exact) {
            form.setFieldsValue({ record_id: props?.default_filter.record_id__exact });
            setHasFilter(true);
        }

    }, []);

    const clearFilter = () => {
        form.resetFields();
        props.onFilterChange(null);
        setVisible(!visible);
        setHasFilter(false);
    }

    const onApplyFilter = (values) => {
        setVisible(false);
        setHasFilter(true);
        let filter_data = {};
        if (values.dates != null && values.dates != undefined) {
            const created_at__gte = new Date(values.dates[0].format("YYYY-MM-DDT00:00:00"));
            const created_at__lte = new Date(values.dates[1].format("YYYY-MM-DDT23:59:59"));

            filter_data["created_at__gte"] = created_at__gte.toISOString();
            filter_data["created_at__lte"] = created_at__lte.toISOString();

        }
        filter_data["name"] = values.name;
        filter_data["flag"] = values.flag;
        filter_data["selectedFormId"] = formId;

        filter_data["created_by__username__icontains"] = values.user_name;
        filter_data["updated_by__username__icontains"] = values.user_name2;
        if (values?.record_id != null && values?.record_id != '') {
            filter_data["record_id__exact"] = values.record_id;
        }
        props.onFilterChange(filter_data);
    }

    useEffect(() => {
        FormService.getFlags(formId).then(res => {
            setFlags(res?.flags);
        })
    }, []);


    const content = (
        <Form form={form} layout="vertical" autoComplete="off" onFinish={onApplyFilter}>

            <Form.Item label="By Ref No" name="record_id">
                <Input style={{ width: '100%' }} placeholder={"Search by reference number"} />
            </Form.Item>

            <Form.Item label="By Record Name" name="name">
                <Input style={{ width: '100%' }} placeholder={"Search by record name"} />
            </Form.Item>

            <Form.Item label="By Record Created By User Name" name="user_name">
                <Input style={{ width: '100%' }} placeholder={"Search by first name, last name and username"} />
            </Form.Item>

            <Form.Item label="By Record Modified By User Name" name="user_name2">
                <Input style={{ width: '100%' }} placeholder={"Search by first name, last name and username"} />
            </Form.Item>

            <Form.Item label="By Dates" name="dates">
                <RangePicker style={{ width: '100%' }} />
            </Form.Item>


            <Form.Item label="Flags" name="flag">
                <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select"
                >
                    {
                        flags && flags.map(flag => (
                            <Option key={`flag_${flag}`} value={flag} >{flag}</Option>
                        ))
                    }
                </Select>
            </Form.Item>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button type="default" onClick={clearFilter}>
                    Clear Filter
                </Button>
                <Button type="primary" htmlType="submit">
                    Apply Filter
                </Button>
            </div>
        </Form>
    );


    return (
        <div>
            {
                hasFilter ? (
                    <Button
                        type="primary"
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => {
                            form.resetFields();
                            props.onFilterChange(null);
                            setHasFilter(false);
                        }}
                    />
                ) : null
            }
            &nbsp;
            <Button type="primary" icon={<FilterOutlined />} onClick={showDrawer}>
                Filter
            </Button>

            <Drawer
                title="Filters"
                bodyStyle={{ paddingTop: 5 }}
                placement={'right'}
                closable={false}
                onClose={showDrawer}
                visible={visible}>
                {content}
            </Drawer>

        </div>
    );

}


export default RecordsFilter;